{
  "colorFormat": "Formato da cor",
  "hex": "Hexadecimal",
  "hsb": "HSB",
  "hsl": "HSL",
  "rgb": "RGB"
}
